import React, { FC } from "react";
import { GalleryCollage } from "./GalleryCollage";
import { Gallery } from "../Gallery";

export type IGalleryItemProps =
  | {
      type: "video";
      src: string;
      caption?: string;
      thumbnail?: string;
    }
  | {
      type: "image";
      src: string;
      alt: string;
      caption?: string;
    };

interface GalleryProps {
  gallery: { md: IGalleryItemProps[]; original: IGalleryItemProps[] };
}

const GalleryNew: FC<GalleryProps> = ({ gallery }) => {
  if (gallery.md.length === 0) {
    return null;
  }

  if (gallery.md.length === 1) {
    return <Gallery gallery={gallery} />;
  }

  if (gallery.md.length >= 2) {
    return (
      <div>
        <div className="max-md:hidden">
          <GalleryCollage gallery={gallery} />
        </div>
        <div className="md:hidden">
          <Gallery gallery={gallery} />
        </div>
      </div>
    );
  }

  return <Gallery gallery={gallery} />;
};

export default GalleryNew;
